// extracted by mini-css-extract-plugin
export default {"overallTotal":"v4Ck8O"};